import { NBSP } from 'shared/constants/text';

/** Запрещает перенос строки внутри значения: пробелы → неразрывные, как `<nobr>` в шаблонах монолита */
export const noBreak = (value: string): string => value.replace(/ /g, NBSP);
